export const hasSelectedInbox = inboxIds => inboxIds.length > 0;

export const isInboxSelected = (inboxIds, inboxId) => {
  return inboxIds.includes(inboxId);
};

export const toggleInboxSelection = (inboxIds, inboxId) => {
  if (isInboxSelected(inboxIds, inboxId)) {
    return inboxIds.filter(id => id !== inboxId);
  }

  return [...inboxIds, inboxId];
};
